<template>
    <div class="item">
        <div class="head">
            <div class="name">
                <div class="quantity" v-if="option.quantity > 1">{{ option.quantity }}x</div>
                {{ translate(option.name) }}
            </div>
            <div class="price">
                <CartItemPrice
                    v-if="option.singlePrice > 0"
                    class="cart-item-option-price"
                    :item="option"
                    :quantity="nextMultiplier"
                    @click="onPriceClick"
                />
            </div>
        </div>
        <div class="subs" v-if="option.options.length">
            <CartItemOptionGroup
                v-for="optionGroup in option.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :multiplier="nextMultiplier"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ICartItem } from "@/data/model/Customer";
    import { useCartStore } from "@/data/stores/cart";
    import { translate } from "@/shared/localization/language";
    import { computed } from "vue";

    import CartItemOptionGroup from "@/app/components/cart/CartItemOptionGroup.vue";
    import CartItemPrice from "@/components/cart/CartItemPrice.vue";

    const cart = useCartStore();

    // define properties
    const props = defineProps<{
        option: ICartItem;
        multiplier: number;
    }>();

    // define computed
    const nextMultiplier = computed(() => props.multiplier * props.option.quantity);

    function onPriceClick() {
        if (!props.option.hasDiscount) {
            return;
        }

        cart.showConfirmItemDiscountsRemovalPopup(props.option);
    }
</script>

<style lang="scss"></style>
